/** 金額計算(サーバと同一): 税抜/税込 (P2) */
import type { Product, PaymentMethod, OrderItem } from '../api/purchaseApi';

export function excludedOf(p: Product, count: number, method: PaymentMethod): number {
  if (p.unit === 'per_user_month') {
    return method === 'monthly12' ? p.unitPrice * count : p.unitPrice * 12 * count;
  }
  return p.unitPrice * count;
}
export function includedOf(p: Product, count: number, method: PaymentMethod): number {
  return Math.round(excludedOf(p, count, method) * (1 + Number(p.taxRate)));
}

/**
 * 年額換算(税抜)。表示用: GBなび(per_user_month)は月額×12、その他(per_user_year)は単価×人数。
 * ※ 実際の請求(GBなびは毎月)は変えず、申込サマリの見せ方だけを年額総額に統一するために使う。
 */
export function annualExcludedOf(p: Product, count: number): number {
  return p.unit === 'per_user_month' ? p.unitPrice * 12 * count : p.unitPrice * count;
}
export function annualIncludedOf(p: Product, count: number): number {
  return Math.round(annualExcludedOf(p, count) * (1 + Number(p.taxRate)));
}
/** 1回目支払いの明細ラベル。GBなび: 月払い="月¥700/人" / 一括="月¥700/人 年間"。その他="1回 ¥10,000"。 */
export function firstPayBreakdown(p: Product, method: PaymentMethod): string {
  if (p.unit === 'per_user_month') {
    return method === 'monthly12'
      ? `月¥${p.unitPrice.toLocaleString()}/人`
      : `月¥${p.unitPrice.toLocaleString()}/人 年間`;
  }
  return `1回 ¥${p.unitPrice.toLocaleString()}`;
}
/** 契約内容(年間)の明細ラベル。GBなび="月¥700/人 年間"。その他="1回 ¥10,000"。 */
export function contractBreakdown(p: Product): string {
  return p.unit === 'per_user_month'
    ? `月¥${p.unitPrice.toLocaleString()}/人 年間`
    : `1回 ¥${p.unitPrice.toLocaleString()}`;
}
/** サーバ確定済み注文明細(OrderItem)を年額換算する表示用ヘルパー群。 */
export function annualExcludedOfItem(i: OrderItem): number {
  // 月払い(GBなび)は amountExcluded が月額なので ×12。一括はそのまま年額。
  return i.paymentMethod === 'monthly12' ? i.amountExcluded * 12 : i.amountExcluded;
}
export function annualIncludedOfItem(i: OrderItem): number {
  return i.paymentMethod === 'monthly12' ? i.amountIncluded * 12 : i.amountIncluded;
}
/** 1回目支払いの明細ラベル(OrderItem)。GBなび: 月払い="月¥700/人" / 一括="月¥700/人 年間"。 */
export function firstPayBreakdownItem(i: OrderItem): string {
  if (i.productCode === 'GB_NAVI') {
    return i.paymentMethod === 'monthly12'
      ? `月¥${i.unitPrice.toLocaleString()}/人`
      : `月¥${i.unitPrice.toLocaleString()}/人 年間`;
  }
  return `1回 ¥${i.unitPrice.toLocaleString()}`;
}
/** 契約内容(年間)の明細ラベル(OrderItem)。GBなび="月¥700/人 年間"。 */
export function contractBreakdownItem(i: OrderItem): string {
  return i.productCode === 'GB_NAVI'
    ? `月¥${i.unitPrice.toLocaleString()}/人 年間`
    : `1回 ¥${i.unitPrice.toLocaleString()}`;
}
export const yen = (n: number) => `¥${n.toLocaleString()}`;
